export default Object.freeze({
    AUTO_TOPUP_STATUS_ERROR: -1,
    AUTO_TOPUP_STATUS_NOT_POSSIBLE: 0,
    AUTO_TOPUP_STATUS_NOT_ACTIVE: 1,
    AUTO_TOPUP_STATUS_ACTIVE_SEPA: 2,
    AUTO_TOPUP_STATUS_ACTIVE_CREDIT_CARD: 3,
    AUTO_TOPUP_STATUS_NOT_REGISTERED: -4,
    AUTO_TOPUP_STATUS_REGISTRATION_IN_PROGRESS: -5
})